import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
} from "@mui/material";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import { FaUserEdit } from "react-icons/fa";
import FilterLoader from "../../../../components/Loader/FilterLoader";
import { useDispatch, useSelector } from "react-redux";
import { changeFilterLoader, changePageNumber } from "../../../../redux/slices/filterSlice";
import DateRangeSelector from "../../../../components/Filters/DateRangeSelector";
import FieldAgentAPI from "../../../../services/field-agent-api";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import styles from "./Merchant.module.scss";

export default function Merchant({ id }) {
  const [data, setData] = useState([]);

  const [totalPage, setTotalPage] = useState(1);
  const [totalLeads, setTotalLeads] = useState(null);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { pageNumber, filterLoader } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  const { fieldAgentLeadListAPI } = new FieldAgentAPI();

  const navigate = useNavigate();

  useEffect(() => {
    fetchLeadDetails();
  }, [pageNumber, filterLoader]);

  const fetchLeadDetails = async () => {
    const res = await fieldAgentLeadListAPI(id, pageNumber);
    if (res.ok) {
      setData(res.data.leads);
      setTotalPage(res.data.totalPages);
      setTotalLeads(res.data.totalRows);
    }
    dispatch(changeFilterLoader(false));
  };

  // console.log(data);

  // console.log("search------------", search);

  const filteredData = data?.filter((row) =>
    [row.name, row.mobile, row.email].some((field) => field?.toLowerCase().includes(search?.toLowerCase()))
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <Card elevation={0} sx={{ py: 1, borderRadius: 3 }}>
        <CardHeader
          action={
            <Box display="flex">
              <Box>
                <input
                  type="text"
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Seach by name, email, phone"
                  className={styles.searchBox}
                />
              </Box>
              <DateRangeSelector />
            </Box>
          }
          title={
            <Box className="header-title">
              <Typography variant="h4">Field Agent Report</Typography>
            </Box>
          }
        />

        <CardContent>
          <TableContainer component={Paper}>
            <Table aria-label="lead table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Register Date</TableCell>
                  <TableCell>Payout Received</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 &&
                  filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.leadID}>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell>{row.mobile}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{moment(new Date(row.created_date)).format("MMM DD YYYY")}</TableCell>
                        <TableCell>{row.payout === 1 ? "Received" : "Not Received"}</TableCell>
                        <TableCell>
                          {row.status === "In Active" ? (
                            <IconButton aria-label="delete" onClick={() => navigate(`/profile?id=${row.id}`)}>
                              <FaUserEdit size={20} />
                            </IconButton>
                          ) : (
                            row.status
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}

                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No results found
                    </TableCell>
                  </TableRow>
                )}

                {/* {filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <TableRow key={row.leadID}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell>{row.mobile}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{moment(new Date(row.created_date)).format("MMM DD YYYY")}</TableCell>
                      <TableCell>{row.payout === 1 ? "Received" : "Not Received"}</TableCell>
                      <TableCell>
                        {row.status === "In Active" ? (
                          <IconButton aria-label="delete" onClick={() => navigate(`/profile?id=${row.id}`)}>
                            <FaUserEdit size={20} />
                          </IconButton>
                        ) : (
                          row.status
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No results found
                    </TableCell>
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          {/* <Box sx={{ mt: 4 }} display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              {totalLeads > 0 && (
                <Typography variant="body2">
                  Total Leads: <strong>{totalLeads}</strong>
                </Typography>
              )}
            </Box>
            <Box>
              <ResponsivePagination
                current={pageNumber}
                total={totalPage}
                onPageChange={(page) => {
                  dispatch(changePageNumber(page));
                  dispatch(changeFilterLoader(true));
                }}
                maxWidth={400}
              />
            </Box>
          </Box> */}
        </CardContent>
      </Card>

      {/* Filter Loader */}
      {filterLoader && <FilterLoader />}
    </>
  );
}
